import { User, Mail, Edit2, Save, X } from 'lucide-react';

export const UserProfileForm = ({ user, isEditing, formData, onEdit, onSave, onCancel, onFieldChange }) => {
  const displayData = isEditing ? formData : user;

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-bold text-gray-900">Mon Profil</h2>
        {!isEditing && (
          <button
            onClick={onEdit}
            className="flex items-center gap-2 px-4 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition"
          >
            <Edit2 className="w-4 h-4" />
            Modifier
          </button>
        )}
      </div>

      {/* Profile Fields */}
      <div className="space-y-4">
        {/* Email */}
        <div className="flex items-center gap-4 p-4 bg-gray-50 rounded-lg">
          <Mail className="w-5 h-5 text-gray-400" />
          <div className="flex-1">
            <label className="text-sm text-gray-600">Email</label>
            {isEditing ? (
              <input
                type="email"
                value={displayData.email || ''}
                onChange={(e) => onFieldChange('email', e.target.value)}
                className="w-full mt-1 px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500"
              />
            ) : (
              <p className="text-gray-900 font-medium">{displayData.email}</p>
            )}
          </div>
        </div>

        {/* First Name */}
        <div className="flex items-center gap-4 p-4 bg-gray-50 rounded-lg">
          <User className="w-5 h-5 text-gray-400" />
          <div className="flex-1">
            <label className="text-sm text-gray-600">Prénom</label>
            {isEditing ? (
              <input
                type="text"
                value={displayData.first_name || ''}
                onChange={(e) => onFieldChange('first_name', e.target.value)}
                className="w-full mt-1 px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500"
              />
            ) : (
              <p className="text-gray-900 font-medium">{displayData.first_name}</p>
            )}
          </div>
        </div>

        {/* Last Name */}
        <div className="flex items-center gap-4 p-4 bg-gray-50 rounded-lg">
          <User className="w-5 h-5 text-gray-400" />
          <div className="flex-1">
            <label className="text-sm text-gray-600">Nom</label>
            {isEditing ? (
              <input
                type="text"
                value={displayData.last_name || ''}
                onChange={(e) => onFieldChange('last_name', e.target.value)}
                className="w-full mt-1 px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500"
              />
            ) : (
              <p className="text-gray-900 font-medium">{displayData.last_name}</p>
            )}
          </div>
        </div>
      </div>

      {/* Action Buttons */}
      {isEditing && (
        <div className="flex gap-3">
          <button
            onClick={onSave}
            className="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition"
          >
            <Save className="w-4 h-4" />
            Enregistrer
          </button>
          <button
            onClick={onCancel}
            className="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-gray-200 text-gray-900 rounded-lg hover:bg-gray-300 transition"
          >
            <X className="w-4 h-4" />
            Annuler
          </button>
        </div>
      )}
    </div>
  );
};
